import React from "react";

const Contact = () => (
	<section id="contact" className="py-16 px-6 max-w-3xl mx-auto">
		<h3 className="text-3xl font-bold text-red-500 mb-4">Contact Us</h3>
		<form className="space-y-4">
			<input
				type="text"
				placeholder="Your Name"
				className="w-full p-3 border rounded"
				required
			/>
			<input
				type="email"
				placeholder="Your Email"
				className="w-full p-3 border rounded"
				required
			/>
			<textarea
				placeholder="Message"
				rows="5"
				className="w-full p-3 border rounded"
				required
			></textarea>
			<button
				className="bg-red-500 text-white px-6 py-2 rounded hover:bg-green-700"
				type="submit"
			>
				Send Message
			</button>
		</form>
	</section>
);

export default Contact;
